import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { GUEST_KEY } from '@makyoapp/makyo-common'
import { ClipboardCheck16 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonVariant } from '@makyoapp/makyo-ui'

import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

import { DeleteRowAction } from './components/DeleteRowAction'
import { LayoutLangDropdown } from './components/LayoutLangDropdown'
import { LayoutSearchbox } from './components/LayoutSearchbox'
import { LayoutSettingsMenu } from './components/LayoutSettingsMenu'
import { LayoutUserDropdown } from './components/LayoutUserDropdown'
import { useGridLayoutOptions } from './hooks/useGridLayoutOptions'

// Generate users options for user dropdown
// todo: find a way to only listen to user data change
const usersOptions = [
  {
    id: GUEST_KEY,
    email: '',
    name: 'Guest',
    photo: '',
  },
  // ...getUsersOption(userLanguage, data, userTable),
  // todo: add users option, see how its done in AppAuthContext
]

/**
 * New Db Table Layout Header (Right)
 *  - search
 *  - language dropdown
 *  - user dropdown
 *  - settings menu
 *
 *
 * @todo: generate users option, see how its done in AppAuthContext
 */
export default function DbTableHeaderRightSection() {
  const { t } = useTranslation()
  const { projectId } = useParams()

  const {
    activeTable,
    userLanguage,
    setUserLanguage,
    userSpecific,
    setUserSpecific,
    selection,
    handleDeleteRowsSelection,
    columnClipboard,
    handlePasteColumn,
  } = useGridV2Context()

  const showDeleteSelection = selection && selection.rows.length > 0

  // access layout options to toggle show language & user dropdown
  const [layoutOptions] = useGridLayoutOptions()

  const changeActiveLanguage = (lng: string) => {
    const activeLanguages = JSON.parse(localStorage.getItem(`activeLanguages:${projectId}`) || '{}')
    activeLanguages[projectId!] = lng
    localStorage.setItem(`activeLanguages:${projectId}`, JSON.stringify(activeLanguages))
    setUserLanguage(lng)
  }

  const [isLoadingPasteColumn, setIsLoadingPasteColumn] = useState(false)

  const showClipboardButton = columnClipboard && activeTable?.id !== columnClipboard.tbl && !activeTable?.isSnapshot

  return (
    <>
      {showClipboardButton && (
        <Button
          title={t('Paste Column Here')}
          variant={ButtonVariant.Outlined}
          squared
          noPadding
          onClick={() => handlePasteColumn()}
          disabled={isLoadingPasteColumn}
        >
          {isLoadingPasteColumn ? <span className='loading spin' /> : <ClipboardCheck16 />}
        </Button>
      )}

      <LayoutSearchbox />

      {layoutOptions.showLang && <LayoutLangDropdown value={userLanguage} onChange={changeActiveLanguage} />}

      {layoutOptions.showUser && (
        <LayoutUserDropdown value={userSpecific} onChange={setUserSpecific} options={usersOptions} />
      )}

      {showDeleteSelection && <DeleteRowAction onDelete={handleDeleteRowsSelection} />}

      <LayoutSettingsMenu />
    </>
  )
}
